import Box from "@mui/material/Box";
import PageTitle from "shared/ui/PageTitle";
import DashboardStatistics from "../components/DashboardStatistics";

const Dashboard = () => {

    return (
        <Box component="main">
            <PageTitle>Statistici</PageTitle>
            <DashboardStatistics/>
        </Box>
    );
};

export default Dashboard;
